import React from 'react';
import { Box, Typography, Button, useTheme, useMediaQuery } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, EffectFade } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';

// Import local images
import slide1Img from '../assets/maingallery/slide1.png';
import slide2Img from '../assets/maingallery/slide2.png';
import slide3Img from '../assets/maingallery/slide3.png';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

const slides = [
  {
    id: 1,
    title: 'Altyapı Derdine Son!',
    subtitle: 'Fişe takıp hemen bağlanabileceğiniz yüksek hızlı internet.',
    image: slide1Img,
  },
  {
    id: 2,
    title: 'Her Yerde Sizinle',
    subtitle: 'Yazlıkta, ofiste, yeni evinizde... Fiber hızında internet hep yanınızda.',
    image: slide2Img,
  },
  {
    id: 3,
    title: 'Taahhüt Yok, Özgürlük Var',
    subtitle: 'Uzun süreli sözleşmelerle uğraşmadan, özgürce internetin keyfini çıkarın.',
    image: slide3Img,
  }
];

const HeroSlider = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();

  return (
    <Box sx={{ width: '100%', height: { xs: '60vh', md: '80vh' }, position: 'relative' }}>
      <Swiper
        modules={[Autoplay, Pagination, EffectFade]}
        effect="fade"
        spaceBetween={0}
        slidesPerView={1}
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        style={{ width: '100%', height: '100%' }}
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <Box
              sx={{
                width: '100%',
                height: '100%',
                backgroundImage: `linear-gradient(rgba(0, 41, 90, 0.7), rgba(0, 41, 90, 0.4)), url(${slide.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                color: 'white',
                textAlign: 'center',
                px: 2,
              }}
            >
              <Typography
                variant={isMobile ? "h4" : "h2"}
                component="h1"
                gutterBottom
                sx={{ fontWeight: 'bold', maxWidth: '800px', textShadow: '0px 2px 4px rgba(0,0,0,0.5)' }}
              >
                {slide.title}
              </Typography>
              <Typography
                variant={isMobile ? "body1" : "h5"}
                sx={{ mb: 4, maxWidth: '600px', textShadow: '0px 1px 3px rgba(0,0,0,0.5)' }}
              >
                {slide.subtitle}
              </Typography>
              <Button
                variant="contained"
                color="secondary"
                size="large"
                onClick={() => navigate('/application')}
                sx={{
                  py: 1.5,
                  px: 4,
                  fontSize: '1.1rem',
                  color: 'primary.main',
                  '&:hover': {
                    backgroundColor: 'secondary.light',
                    color: 'white'
                  }
                }}
              >
                Hemen Başvur
              </Button>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
      {/* Custom Styles for Swiper Pagination to match theme */}
      <style>
        {`
          .swiper-pagination-bullet {
            background: white !important;
            opacity: 0.5;
          }
          .swiper-pagination-bullet-active {
            background: #D0DF00 !important;
            opacity: 1;
          }
        `}
      </style>
    </Box>
  );
};

export default HeroSlider;
